import React from 'react';
import { FaEnvelope, FaPhone } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { BRAND_NAME, BRAND_TAGLINE } from '../constants/brand';
import '../styles/Footer.css';

const trackFooterLink = (linkName, linkType) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'footer_link_click', {
      event_category: 'navigation',
      event_label: linkName,
      link_type: linkType,
    });
  }
};

const trackSocialClick = (platform) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'social_link_click', {
      event_category: 'social',
      event_label: platform,
    });
  }
};

const SOCIAL_LINKS = [
  {
    id: 'facebook',
    label: 'Facebook',
    href: 'https://facebook.com/khuyungwedstories',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden>
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    ),
  },
  {
    id: 'instagram',
    label: 'Instagram',
    href: 'https://instagram.com/khuyungwedstories',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden>
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
      </svg>
    ),
  },
  {
    id: 'tiktok',
    label: 'TikTok',
    href: 'https://www.tiktok.com/@khuyung.wedstories',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden>
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
      </svg>
    ),
  },
  {
    id: 'youtube',
    label: 'YouTube',
    href: 'https://youtube.com/@khuyungwedstories',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden>
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
      </svg>
    ),
  },
];

const WHATSAPP_URL = `https://wa.me/8801601719735?text=${encodeURIComponent(
  "Hi! I'm contacting you through the Khuyung WedStories website. "
)}`;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" id="site-footer">
      <div className="footer-main">
        <div className="footer-grid">
          <div className="footer-col footer-col--brand">
            <Link
              to="/"
              onClick={() => trackFooterLink('Footer Logo', 'brand')}
              className="footer-logo-link"
            >
              <img
                src="/albums/logo/logo.png"
                alt="Khuyung WedStories"
                className="footer-logo"
                width={96}
                height={96}
              />
            </Link>
            <h3 className="footer-brand-name">{BRAND_NAME}</h3>
            <p className="footer-brand-tagline">{BRAND_TAGLINE}</p>
            <div className="footer-social" role="list" aria-label="Social media">
              {SOCIAL_LINKS.map(({ id, label, href, icon }) => (
                <a
                  key={id}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`footer-social-btn footer-social-btn--${id}`}
                  onClick={() => trackSocialClick(label)}
                  aria-label={label}
                  role="listitem"
                >
                  {icon}
                </a>
              ))}
            </div>
          </div>

          <div className="footer-col footer-col--explore">
            <h4 className="footer-col-title">Explore</h4>
            <ul className="footer-links">
              <li><Link to="/" onClick={() => trackFooterLink('Home', 'quick_link')}>Home</Link></li>
              <li><Link to="/about" onClick={() => trackFooterLink('About Us', 'quick_link')}>About Us</Link></li>
              <li><Link to="/photos" onClick={() => trackFooterLink('Portfolio', 'quick_link')}>Portfolio</Link></li>
              <li><Link to="/films" onClick={() => trackFooterLink('Videos', 'quick_link')}>Films</Link></li>
              <li><Link to="/blogs" onClick={() => trackFooterLink('Blogs', 'quick_link')}>Blogs</Link></li>
              <li><Link to="/write-for-us" onClick={() => trackFooterLink('Write for Us', 'quick_link')}>Write for Us</Link></li>
            </ul>
          </div>

          <div className="footer-col footer-col--services">
            <h4 className="footer-col-title">Services</h4>
            <ul className="footer-links">
              <li><Link to="/photos" onClick={() => trackFooterLink('Wedding Photography', 'service')}>Wedding Photography</Link></li>
              <li><Link to="/films" onClick={() => trackFooterLink('Wedding Cinematography', 'service')}>Wedding Cinematography</Link></li>
              <li><Link to="/book" onClick={() => trackFooterLink('Packages & Book', 'service')}>Packages &amp; Book</Link></li>
              <li>
                <Link to="/budget-calculator" onClick={() => trackFooterLink('Budget Calculator', 'service')}>
                  Budget calculator
                </Link>
              </li>
              <li><Link to="/track-deliverables" onClick={() => trackFooterLink('Track Deliverables', 'quick_link')}>Track deliverables</Link></li>
            </ul>
          </div>

          <div className="footer-col footer-col--contact">
            <h4 className="footer-col-title">Get in touch</h4>
            <div className="footer-contact-card">
              <a href="tel:+8801601719735" className="footer-contact-row">
                <span className="footer-contact-icon" aria-hidden>
                  <FaPhone />
                </span>
                <span>
                  <span className="footer-contact-label">Phone</span>
                  <span className="footer-contact-value">+880 1601 719 735</span>
                </span>
              </a>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-contact-row footer-contact-row--whatsapp"
                onClick={() => trackSocialClick('WhatsApp')}
              >
                <span className="footer-contact-icon footer-contact-icon--wa" aria-hidden>
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488" />
                  </svg>
                </span>
                <span>
                  <span className="footer-contact-label">WhatsApp</span>
                  <span className="footer-contact-value">Message us</span>
                </span>
              </a>
              <a href="mailto:khuyungwedstories@gmail.com" className="footer-contact-row">
                <span className="footer-contact-icon" aria-hidden>
                  <FaEnvelope />
                </span>
                <span>
                  <span className="footer-contact-label">Email</span>
                  <span className="footer-contact-value">khuyungwedstories@gmail.com</span>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom" id="footer-bottom">
        <div className="footer-bottom-inner">
          <p className="footer-copyright">
            &copy; {currentYear} Khuyung WedStories. All rights reserved.
          </p>
          <nav className="footer-legal" aria-label="Legal">
            <Link
              to="/faq"
              className="footer-legal-link"
              onClick={() => trackFooterLink('FAQ', 'legal')}
            >
              FAQ
            </Link>
            <span className="footer-legal-dot" aria-hidden>·</span>
            <Link
              to="/privacy"
              className="footer-legal-link"
              onClick={() => trackFooterLink('Privacy Policy', 'legal')}
            >
              Privacy
            </Link>
            <span className="footer-legal-dot" aria-hidden>·</span>
            <Link
              to="/terms"
              className="footer-legal-link"
              onClick={() => trackFooterLink('Terms & Conditions', 'legal')}
            >
              Terms
            </Link>
            <span className="footer-legal-dot" aria-hidden>·</span>
            <Link
              to="/refund"
              className="footer-legal-link"
              onClick={() => trackFooterLink('Refund & Return Policy', 'legal')}
            >
              Refund
            </Link>
          </nav>
          <p className="footer-credit">
            Developed by{' '}
            <a
              href="https://www.facebook.com/malthasc"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-credit-link"
            >
              Malthas Chakma
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
